import { render, staticRenderFns } from "./TaskIoForm.vue?vue&type=template&id=c64f03a0&scoped=true"
import script from "./TaskIoForm.vue?vue&type=script&lang=js"
export * from "./TaskIoForm.vue?vue&type=script&lang=js"
import style0 from "./TaskIoForm.vue?vue&type=style&index=0&id=c64f03a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64f03a0",
  null
  
)

export default component.exports